import React, { useEffect, useMemo, useState } from 'react';
import {
  AutocompleteInput,
  DateInput,
  required,
  SelectInput,
  TextInput
} from 'react-admin';
import { getCustomers } from '../../../core/services/customer-api.service';
import usePumps from '../../../core/hooks/usePumps';
import { EfficiencyTestCreateCustomer } from './EfficiencyTestCreateCustomer';
import Grid from '@mui/material/Grid';

export const EfficiencyTestsForm = () => {
  const [customerChoices, setCustomerChoices] = useState([]);
  const { data: pumps, isLoading: loadingPumps } = usePumps();

  const pumpChoices = useMemo(
    () =>
      (pumps ?? []).map((pump: any) => ({
        id: pump?.id,
        name: pump?.pumpName
      })),
    [pumps]
  );

  useEffect(() => {
    getCustomerChoices();
  }, []);

  let getCustomerChoices = async () => {
    let customers = await getCustomers();
    const transform = customers?.data.map((customer: any) => {
      return { id: customer?.id, name: customer?.name };
    });
    setCustomerChoices(transform);
  };

  return (
    <Grid container rowSpacing={0} columnSpacing={3}>
      <SelectInput
        optionText="name"
        source="pumpHash"
        label="resources.efficiency-tests.fields.pumpModel"
        validate={[required()]}
        choices={pumpChoices}
        isLoading={loadingPumps}
      />
      <AutocompleteInput
        choices={customerChoices}
        source="customerHash"
        label="resources.efficiency-tests.fields.client"
        createItemLabel="resources.efficiency-tests.fields.create"
        create={
          <EfficiencyTestCreateCustomer refreshCustomers={getCustomerChoices} />
        }
        validate={[required()]}
      />
      <TextInput
        source="identifier"
        label="resources.efficiency-tests.fields.identifier"
      />
      <TextInput
        source="satref"
        label="resources.efficiency-tests.fields.satref"
      />
      <TextInput
        source="orderNumber"
        label="resources.efficiency-tests.fields.orderNumber"
      />
      <DateInput
        label="resources.efficiency-tests.fields.date"
        source="date"
        validate={[required()]}
        defaultValue={new Date()}
      />
    </Grid>
  );
};
